"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskInfoContainer = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const styled_components_1 = require("styled-components");
const FileDown_1 = require("../../../../../common/option/FileDown");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const account_1 = require("../../../../base/account");
const TaskInfoContainerStyled = styled_components_1.styled.div `
	display: flex;
	flex-shrink: 0;
	align-self: stretch;
	flex-direction: column;
	gap: 16px;

	.frame-987343 {
		display: flex;
		flex-direction: column;
		gap: 8px;
		align-items: flex-start;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;
    	white-space: nowrap;
    	text-overflow: ellipsis;
		${({ $isMobile }) => $isMobile
    ? (0, styled_components_1.css) ``
    : (0, styled_components_1.css) `
						width: 400px;
				  `};
	}
	.date {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}
	.label {
		color: var(--color-black, #101010);
		text-align: center;
		font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
		letter-spacing: var(--h5-letter-spacing, -0.02em);
		font-weight: var(--h5-font-weight, 700);
		position: relative;
		text-align: left;

		${({ $isMobile, $isTablet }) => $isMobile
    ? (0, styled_components_1.css) `
						font-size: var(--h5-font-size, 16px);
						line-height: var(--h5-line-height, 24px);
						width: 65px;
				  `
    : $isTablet
        ? (0, styled_components_1.css) `
						font-size: var(--h5-font-size, 16px);
						line-height: var(--h5-line-height, 24px);
						width: fit-content;
				  `
        : (0, styled_components_1.css) `
						font-size: var(--h5-font-size, 16px);
						line-height: var(--h5-line-height, 24px);
						width: fit-content;
				  `}
	}
	.divider {
		background: var(--color-grey-w, #b6bac0);
		flex-shrink: 0;
		width: 1px;
		height: 14px;
		position: relative;
	}
	.value {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
		letter-spacing: var(--b3-letter-spacing, -0.02em);
		font-weight: var(--b3-font-weight, 400);
		position: relative;
		overflow: hidden;
	    white-space: nowrap;
    	text-overflow: ellipsis;
		width: 300px;

		${({ $isMobile, $isTablet }) => $isMobile
    ? (0, styled_components_1.css) `
						font-size: var(--b5-font-size, 14px);
						line-height: var(--b5-line-height, 24px);
				  `
    : $isTablet
        ? (0, styled_components_1.css) `
						font-size: var(--b3-font-size, 16px);
						line-height: var(--b3-line-height, 32px);
				  `
        : (0, styled_components_1.css) `
						font-size: var(--b3-font-size, 16px);
						line-height: var(--b3-line-height, 32px);
				  `}
	}

	.file_values {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
		align-items: center;
		justify-content: flex-start;

		${({ $isMobile }) => $isMobile
    ? `
			flex-direction: column;
		`
    : ``}

		button {
			p {
				text-decoration: underline;
			}
		}
	}
	.view {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}
	.frame-987344 {
		display: flex;
		flex-direction: column;
		gap: 8px;
		align-items: flex-start;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
		${({ $isMobile }) => $isMobile
    ? (0, styled_components_1.css) ``
    : (0, styled_components_1.css) `
						flex: 1;
				  `};
	}
`;
const TaskInfoContainer = ({ isTest, item, isSubmit, isSurvey = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const assignmentRef = (0, react_1.useRef)(null);
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    // p46: 교사/관리자는 테스트 진행기간이 아니어도 첨부파일 다운로드 허용
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const isManager = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsManager)(state));
    const canDownloadAlways = isTeacher || isManager;
    const [className, setClassName] = (0, react_1.useState)(''); // 수업명
    const [startDate, setStartDate] = (0, react_1.useState)(''); // 시작일
    const [endDate, setEndDate] = (0, react_1.useState)(''); // 마감일
    const [duration, setDuration] = (0, react_1.useState)(0); // 시험 시간
    const [questionType, setQuestionType] = (0, react_1.useState)(''); // 문제 유형
    const [attachFileList, setAttachFileList] = (0, react_1.useState)([]); // 첨부파일
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!item)
            return;
        const questionType = item.type === 'OMR (기본형)' || item.type === 'OMR (자유형)'
            ? item.type +
                `${item.subject !== '' ? ' - ' + t(`assignment.${item.subject}`) : ''}`
            : item.type;
        setClassName(item.conference_name);
        setStartDate((0, moment_1.default)(item.startline).format(isTest ? 'YYYY-MM-DD' : 'YYYY-MM-DD, HH:mm'));
        setDuration(item.duration);
        setEndDate((0, moment_1.default)(item.deadline).format('YYYY-MM-DD, HH:mm'));
        setQuestionType(questionType);
        setAttachFileList(item.attachments);
        item.status === 'open' ? setIsOpen(true) : setIsOpen(false);
    }, [item]);
    (0, react_1.useEffect)(() => {
        if (assignmentRef.current)
            assignmentRef.current.value = item.title;
    }, [item.title]);
    return (react_1.default.createElement(TaskInfoContainerStyled, { className: 'task-info-container', "$isMobile": isMobile, "$isTablet": isTablet },
        react_1.default.createElement("div", { className: "sub-info" }, isTest ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "frame-987343" },
                react_1.default.createElement("div", { className: "date" },
                    react_1.default.createElement("div", { className: "label" }, t('assignment.class_name')),
                    react_1.default.createElement("div", { className: "divider" }),
                    react_1.default.createElement("div", { className: "value" }, className || '-')),
                react_1.default.createElement("div", { className: "view" },
                    react_1.default.createElement("div", { className: "label" }, "\uC9C4\uD589\uC77C"),
                    react_1.default.createElement("div", { className: "divider" }),
                    react_1.default.createElement("div", { className: "value" }, startDate))),
            react_1.default.createElement("div", { className: "frame-987344" },
                react_1.default.createElement("div", { className: "date" },
                    react_1.default.createElement("div", { className: "label" }, "\uD480\uC774\uC2DC\uAC04"),
                    react_1.default.createElement("div", { className: "divider" }),
                    react_1.default.createElement("div", { className: "value" },
                        duration,
                        " \uBD84")),
                react_1.default.createElement("div", { className: "attachedfile" },
                    react_1.default.createElement("div", { className: "date" },
                        react_1.default.createElement("div", { className: "label" }, "\uCCA8\uBD80\uD30C\uC77C"),
                        react_1.default.createElement("div", { className: "file_values" },
                            react_1.default.createElement(FileDown_1.FileDown, { isOpen: isOpen, allowAlways: canDownloadAlways, files: attachFileList }))))))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "frame-987343" },
                react_1.default.createElement("div", { className: "view" },
                    react_1.default.createElement("div", { className: "label" }, "\uC2DC\uC791\uC77C"),
                    react_1.default.createElement("div", { className: "divider" }),
                    react_1.default.createElement("div", { className: "value" }, startDate)),
                react_1.default.createElement("div", { className: "view" },
                    react_1.default.createElement("div", { className: "label" }, "\uB9C8\uAC10\uC77C"),
                    react_1.default.createElement("div", { className: "divider" }),
                    react_1.default.createElement("div", { className: "value" }, endDate))),
            react_1.default.createElement("div", { className: "frame-987344" },
                react_1.default.createElement("div", { className: "attachedfile" },
                    react_1.default.createElement("div", { className: "date" },
                        react_1.default.createElement("div", { className: "label" }, "\uCCA8\uBD80\uD30C\uC77C"),
                        react_1.default.createElement("div", { className: "file_values" },
                            react_1.default.createElement(FileDown_1.FileDown, { isOpen: isOpen, allowAlways: canDownloadAlways, files: attachFileList }))))))))));
};
exports.TaskInfoContainer = TaskInfoContainer;
